import { filter } from "rxjs/operators";
import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NfoVedioPopUpComponent } from './nfo-vedio-pop-up/nfo-vedio-pop-up.component';
import { environment } from '../../../environments/environment.prod'
import { RedirectionService } from "@root/shared/services/redirection.service";
import { CommonDataService } from "../../shared/services/common-data.service";
import { Router } from '@angular/router';

@Component({
  selector: "app-nfo",
  templateUrl: "./nfo.component.html",
  styleUrls: ["./nfo.component.scss"],
})
export class NfoComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    public sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private redirectionService : RedirectionService,
    private router: Router,
    public commonDataService: CommonDataService
  ) { }

  showPageNotFound: boolean = false;

  fundDetailsList: any = [];

  nfoProductDetailList: any;

  nfoProductVedioList: any = [];

  embed: any;

  embedYoutubeImg: any;

  productLabel = {
    title: "",
    items: [],
  };

  ngOnInit() {
    // NFO restriction logic
    if (!this.commonDataService.isNfoAccessible()) {
      this.showPageNotFound = true;
      return;
    }
    this.getFundDetails();
  }

  getFundDetails() {
    const obj = {};
    this.apiService.postData(Urls.getTop3Funds, obj).subscribe(
      (response) => {
        this.fundDetailsList = response.data.returnValue;
        const fundDetail = this.fundDetailsList.find((i: { isNfo: string; }) => i.isNfo.toLowerCase() === "yes");
        if (fundDetail) {
          const reqObj = {
            scheme: fundDetail.scheme,
            plan: fundDetail.plan,
          };
          this.apiService.postData(Urls.getProductDetails, reqObj).subscribe(
            (responseData) => {
              this.nfoProductDetailList = responseData.data;
              this.nfoProductDetailList.videos.forEach((element: any) => {
                const vedio: any = {};
                vedio.name = element.videoName;
                vedio.url = this.setVideo(element.videoUrl);
                vedio.urlMain = element.videoUrl;
                this.nfoProductVedioList.push(vedio);
              });
              this.setProductLabel();
            },
            (error) => { }
          );
        }
      },
      (error) => { }
    );
  }

  private setProductLabel() {
    if (this.nfoProductDetailList && this.nfoProductDetailList.productValue) {
      const rawLabel = this.nfoProductDetailList.productValue.productLabel;
      const rawLabelSplit = rawLabel.split("*");
      this.productLabel.title = `${rawLabelSplit[0]}*`;
      this.productLabel.items = rawLabelSplit[1]
        ? rawLabelSplit[1].split(";")
        : [];
    }
  }

  public setVideo(val: string) {
    const link = 'https://www.youtube.com/embed/';
    if (val.startsWith('https://www.youtube.com/watch?')) {
      this.embed = val.split('watch?v=')[1];

    } else if (val.startsWith("https://youtu.be/")) {
      this.embed = val.split("https://youtu.be/")[1];

    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(link + this.embed);
  }

  public getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public investOnline() {
    this.redirectionService.redirectToInvestorPortal();
  }

  public redirectToHome() {
    this.router.navigate(['/']);
  }

  public getVideoThumbnail(url: string) {
    if (url.startsWith('https://www.youtube.com/watch?')) {
      this.embedYoutubeImg = url.split('watch?v=')[1];
    } else if (url.startsWith('https://youtu.be/')) {
      this.embedYoutubeImg = url.split("https://youtu.be/")[1];
    }

    return "https://img.youtube.com/vi/" + this.embedYoutubeImg + "/0.jpg";
  }

  public palyVideo(url: any) {
    let size = "lg";
    if (window.innerWidth <= 768) {
      size = "sm";
    }
    const modalRef = this.modalService.open(NfoVedioPopUpComponent, { size: size, windowClass: 'align-modal-video', backdrop: true, });
    modalRef.componentInstance.videoLink = url;
  }

}
